import { ListenerEffectAPI, ThunkDispatch, UnknownAction } from '@reduxjs/toolkit';
import { fetchSync } from '../sync/sync';

const syncHandler = (listenerApi: ListenerEffectAPI<unknown, ThunkDispatch<unknown, unknown, UnknownAction>, unknown>) => {
  listenerApi.dispatch(fetchSync());
}

export default syncHandler;
